// Returns true of presented a string
export default function isString(obj) {
  return typeof obj === 'string'
}



// WEBPACK FOOTER //
// ./src/isString.js